import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Button as ButtonComponent, RoundedWrapper, Typography } from '@raisin/components-lib';

export const BankDetailsContainer = styled(Container)(({ theme }) => ({
  color: theme.palette.black80.main,
  padding: theme.spacing(0, 6),
}));

export const BankNameTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h4.fontSize,
  },
}));

export const BankDetailItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  alignItems: 'center',
  width: '100%',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(4),
  },

  ':last-of-type': {
    marginBottom: 0,
  },

  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(4),
  },
}));

export const BankInfoLabel = styled(Box)(({ theme, isBold }) => ({
  fontWeight: isBold ? theme.typography.h1.fontWeight : 'normal',
  verticalAlign: 'top',
}));

export const LogoContainer = styled(RoundedWrapper)(({ theme }) => ({
  width: 516,
  height: 516,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(29.5, 24.5, 24.5, 29.5),
  '& img': {
    objectFit: 'contain',
  },
}));

export const OfferListButton = styled(ButtonComponent)({
  alignSelf: 'stretch',
});

export const ButtonContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  justifyContent: 'left',

  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export const OfferListContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(6, 0, 0, 8),
}));

export const Button = styled(ButtonComponent)({
  justifyContent: 'left',
});

export const DetailsHeader = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: theme.spacing(4, 0, 0),
}));

export const DetailsSectionNotice = styled('div')(({ theme }) => ({
  display: 'inline-block',
  padding: theme.spacing(0.5, 3),
  backgroundColor: theme.palette.blue10.main,
  borderRadius: theme.typography.button.borderRadius,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: theme.spacing(2, 0, 2, 3),
  },
}));

export const DetailsSectionWarning = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  padding: theme.spacing(3, 7.5, 3, 3),
  backgroundColor: theme.palette.warning10.main,
  borderRadius: theme.typography.button.borderRadius,
}));

export const Heading = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey900.main,
  padding: theme.spacing(0, 0, 4),
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h4.fontSize,
    lineHeight: theme.typography.h4.lineHeight,
  },
}));

export const TextContainerGrid = styled('div')(({ theme }) => ({
  color: theme.palette.grey700.main,
  whiteSpace: 'pre-line',
}));

export const DetailsSection = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(12),
}));

export const BackButton = styled(Button)(({ theme, hidden }) => ({
  display: 'inline-flex',
  margin: 'auto',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'left',
  },

  ...(hidden && {
    visibility: 'hidden',
  }),
}));

export const TitleContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey900.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.h5.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
  },
}));

export const DepositInfoContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
});

export const DepositLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.body1.fontWeight,
}));

export const DetailsSectionContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: '66.667%',
  },
}));
